import { render, staticRenderFns } from "./FrontendRoot.vue?vue&type=template&id=1a1d9a80&scoped=true&"
import script from "./FrontendRoot.vue?vue&type=script&lang=js&"
export * from "./FrontendRoot.vue?vue&type=script&lang=js&"
import style1 from "./FrontendRoot.vue?vue&type=style&index=1&id=1a1d9a80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1d9a80",
  null
  
)

export default component.exports